/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/* @relayHash 75a83ac0d6001441a149101267152ef3 */

import { ConcreteRequest } from "relay-runtime";

export type LoyaltyApprovalStatus = "APPROVED" | "DECLINED" | "INELIGIBLE" | "LMS_ONLY" | "PENDING" | "PENDING_AWAITING_TC" | "%future added value";
export type AuthenticatedHeaderQueryVariables = {};
export type AuthenticatedHeaderQueryResponse = {
    readonly viewer: {
        readonly partnerUsers: {
            readonly edges: ReadonlyArray<{
                readonly node: {
                    readonly partnerAccount?: {
                        readonly id: string | null;
                        readonly partnerLoyaltyProfile: {
                            readonly loyaltyApprovalStatus: LoyaltyApprovalStatus | null;
                        } | null;
                    } | null | undefined;
                };
            } | null>;
        } | null;
    } | null;
};
export type AuthenticatedHeaderQuery = {
    readonly response: AuthenticatedHeaderQueryResponse;
    readonly variables: AuthenticatedHeaderQueryVariables;
};



/*
query AuthenticatedHeaderQuery {
  viewer {
    partnerUsers {
      edges {
        node {
          __typename
          ... on PartnerUser {
            partnerAccount {
              id
              partnerLoyaltyProfile {
                loyaltyApprovalStatus
                id
              }
            }
          }
          id
        }
      }
    }
    id
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "loyaltyApprovalStatus",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AuthenticatedHeaderQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CorePartnerUserConnection",
            "kind": "LinkedField",
            "name": "partnerUsers",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CorePartnerUserEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PartnerAccount",
                            "kind": "LinkedField",
                            "name": "partnerAccount",
                            "plural": false,
                            "selections": [
                              (v0/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "PartnerLoyaltyProfile",
                                "kind": "LinkedField",
                                "name": "partnerLoyaltyProfile",
                                "plural": false,
                                "selections": [
                                  (v1/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "PartnerUser",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "AuthenticatedHeaderQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CorePartnerUserConnection",
            "kind": "LinkedField",
            "name": "partnerUsers",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CorePartnerUserEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__typename",
                        "storageKey": null
                      },
                      (v0/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PartnerAccount",
                            "kind": "LinkedField",
                            "name": "partnerAccount",
                            "plural": false,
                            "selections": [
                              (v0/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "PartnerLoyaltyProfile",
                                "kind": "LinkedField",
                                "name": "partnerLoyaltyProfile",
                                "plural": false,
                                "selections": [
                                  (v1/*: any*/),
                                  (v0/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "PartnerUser",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "75a83ac0d6001441a149101267152ef3",
    "metadata": {},
    "name": "AuthenticatedHeaderQuery",
    "operationKind": "query",
    "text": null
  }
};
})();
(node as any).hash = 'eeeaf6e679648415389b50baa87744f4';
export default node;
